import { FilterField } from "../../pages/Bookings/BookingFilters";
import { controlStyle } from "../../helpers/constants";

type Props = {
  label?: string;
  value?: string;
  onChange: (date: string) => void;
  disabled?: boolean;
};

export default function DateInput({
  label = "Filtrer par jour",
  value,
  onChange,
  disabled,
}: Props) {
  return (
    <FilterField label={label}>
      <input
        id="sessionDate"
        type="date"
        className="form-control px-3"
        style={controlStyle}
        value={value || ""}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
    </FilterField>
  );
}
